// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__qoSVh","input":"styles_input__oDbgA","label":"styles_label__2MeKI","rot":"styles_rot__chsJV"};